export default __webpack_public_path__ + "static/media/work-dark.067de575.svg";